import React from "react";
import "../../styles/ServicesHero.css";



function ServicesHero() {
  return (
    <div className="services-hero-container">
      <div className="content">

        <div className="services-header-section">
          <h1>
          Discover our distinctive services
          </h1>
          <p>
          Go Talk Therapy supports individuals through a range of mental health treatments
          </p>
          
        </div>
      </div>
    </div>
  );
}

export default ServicesHero;
